import React from 'react'
import { styled } from '@mui/material'

const PageContainer = styled('div')(() => ({
  height: '100%',
  width: '100%'
}))

const StyledPageContainer = (props) => {
  return <PageContainer>{props.children}</PageContainer>
}

export default StyledPageContainer
